<template>
  <div ref="VueFocusLoopContainer" class="focus-loop-wrapper">
    <div :tabindex="tabindex" @focus="handleFocusStart" />
    <div ref="focusLoop" class="focus-loop">
      <slot />
    </div>
    <div :tabindex="tabindex" @focus="handleFocusEnd" />
  </div>
</template>

<script>
/**
 * Some of this adapted from https://github.com/vue-a11y/vue-focus-loop
 */
const focusableElementsSelector = [
  ...['input', 'select', 'button', 'textarea'].map(
    (field) => `${field}:not([disabled])`,
  ),
  'a[href]',
  'video[controls]',
  'audio[controls]',
  '[tabindex]:not([tabindex^="-"])',
  '[contenteditable]:not([contenteditable="false"])',
].join(',')

const ariaHiddenElements = []

export default {
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      previouslyFocusedElement: null,
    }
  },
  computed: {
    tabindex() {
      return this.enabled ? 0 : -1
    },
  },
  watch: {
    enabled(newValue) {
      if (newValue) {
        this.previouslyFocusedElement = document.activeElement
        this.lockForSwipeScreenReader()
        setTimeout(() => {
          this.handleFocusEnd()
        }, 200)
      } else if (this.previouslyFocusedElement) {
        setTimeout(() => {
          this.previouslyFocusedElement.focus()
        }, 200)
      }
    },
  },
  methods: {
    getFocusableElements() {
      const focusableElements = this.$refs.focusLoop.querySelectorAll(
        focusableElementsSelector,
      )
      if (focusableElements && focusableElements.length)
        return focusableElements
      return []
    },
    handleFocusStart() {
      const elements = this.getFocusableElements()
      if (elements.length > 0) {
        const index = this.alreadyFocused ? elements.length - 1 : 0
        this.alreadyFocused = true
        elements[index].focus()
      }
    },
    handleFocusEnd() {
      const elements = this.getFocusableElements()
      if (elements.length > 0) {
        elements[0].focus()
      }
    },
    focusFirstMenuElement() {
      const elements = this.getFocusableElements()
      if (elements.length > 2) {
        elements[2].focus()
      }
    },
    focusPreviousElement() {
      this.previouslyFocusedElement.focus()
    },
    getElementsToAriaHidden(focusLoopContainer) {
      function getElements(element) {
        const children = Array.from(element.children)
        children.forEach((el) => {
          if (el === focusLoopContainer) return
          if (!el.contains(focusLoopContainer)) {
            ariaHiddenElements.push(el)
            return
          }
          getElements(el)
        })
      }
      getElements(document.body)
    },
    lockForSwipeScreenReader() {
      if (this.enabled)
        this.getElementsToAriaHidden(this.$refs.VueFocusLoopContainer)
      ariaHiddenElements.forEach((el) => {
        if (
          ['SCRIPT', 'STYLE'].includes(el.nodeName) ||
          el.hasAttribute('aria-live')
        )
          return
        el.setAttribute('aria-hidden', this.enabled.toString())
      })
    },
  },
}
</script>
